import { useEffect } from "react";

import EcommerceItem from "@/types/gtm/EcommerceItem";
import { QuoteReviewGtmEvent } from "@/types/gtm/QuoteReviewEvent";

import { defaultQuoteReviewData } from "./default-quote-review-event-data";

export interface ExtendedWindow extends Window {
  dataLayer?: QuoteReviewGtmEvent[];
}

type QuoteReviewPageLoadProps = {
  quoteReviewData: Partial<QuoteReviewGtmEvent | null>;
  policyItems: EcommerceItem[] | null;
  isReady: boolean;
};

const useGtmQuoteReviewOption = (props: QuoteReviewPageLoadProps) => {
  const { quoteReviewData, policyItems, isReady } = props;
  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (quoteReviewData !== null && policyItems !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        const eventData = {
          ...defaultQuoteReviewData,
          ...quoteReviewData,
        };
        if (eventData.ecommerce) eventData.ecommerce.items = policyItems;

        extendedWindow.dataLayer.push({
          ...eventData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmQuoteReviewOption;
